import { ActionBar, PageLoader, useLookup } from "@redriver/cinnamon";
import React from "react";
import { Button, Icon } from "semantic-ui-react";
import { useHistory } from "react-router-dom";
import { SystemRoutes } from "constants/routes";
import { dashboardDetailsLookup } from "./lookups";
import { countriesLookup } from "features/EditRepDetails/lookups";

const Dashboard = () => {
  const [{ response, loading }] = useLookup(dashboardDetailsLookup);
  useLookup(countriesLookup); // trigger load of countries as soon as possible
  const history = useHistory();
  const busy = loading;

  const hasAgreedToTerms = response?.hasAcceptedTerms == true;
  const hasCompletedPersonalDetails =
    response?.hasCompletedPersonalDetails == true;
  return (
    <div>
      {busy ? (
        <PageLoader />
      ) : (
        <div>
          <p>Welcome to the Resort Reps Portal!</p>

          <ActionBar className="rep-actions">
            <ActionBar.Item>
              <Button
                primary
                fluid
                onClick={() =>
                  history.push({
                    pathname: SystemRoutes.Conditions,
                    state: {
                      hasAgreedToTerms,
                    },
                  })
                }
                style={{ position: "relative" }}
              >
                Accept Terms of Contract
                {hasAgreedToTerms && (
                  <Icon
                    name="check"
                    style={{ position: "absolute", right: 0 }}
                  />
                )}
              </Button>
            </ActionBar.Item>

            <ActionBar.Item>
              <Button
                onClick={() => history.push(SystemRoutes.RepDetails)}
                primary
                disabled={!response?.hasAcceptedTerms}
                fluid
                style={{ position: "relative" }}
              >
                {response?.hasCompletedPersonalDetails == true
                  ? "View"
                  : "Enter"}{" "}
                Personal Details
                {hasCompletedPersonalDetails && (
                  <Icon
                    name="check"
                    style={{ position: "absolute", right: 0 }}
                  />
                )}
              </Button>
            </ActionBar.Item>
            <ActionBar.Item>
              <Button
                primary
                fluid
                onClick={() => history.push(SystemRoutes.Bookings)}
                disabled={
                  !response?.hasAcceptedTerms ||
                  !response?.hasCompletedPersonalDetails
                }
              >
                View Assigned Bookings
              </Button>
            </ActionBar.Item>
            <ActionBar.Item>
              <Button
                primary
                fluid
                onClick={() => history.push(SystemRoutes.TemplateDocuments)}
              >
                View Template Documents
              </Button>
            </ActionBar.Item>
            <ActionBar.Item>
              <Button
                primary
                fluid
                onClick={() => history.push(SystemRoutes.Travel)}
                disabled={
                  !response?.hasAcceptedTerms ||
                  !response?.hasCompletedPersonalDetails
                }
              >
                View Travel Arrangements
              </Button>
            </ActionBar.Item>
          </ActionBar>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
